import React from "react";
// import dataCandi from "../../assets/fakeData/dataCandi";
import { useState } from "react";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import LoginHeader from "../../components/header/LoginHeader";
import MobileHeader from "../../components/header/MobileHeader";
import PasswordCard from "./PasswordCard";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
// import Breadcrumb from "../../components/breadcrumb";

ChangePassword.propTypes = {};

function ChangePassword(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };
  return (
    <>
      <LoginMobileHeader handleMobile={handleMobile} />
      <LoginHeader clname="act1" handleMobile={handleMobile} />

      {/* <Breadcrumb title="Applied Jobs" className="breadcrumb-section" /> */}

      <PasswordCard />
      <Footer />
      <Gotop />
    </>
  );
}

export default ChangePassword;



